import React from 'react';
import styled from 'styled-components';

// Предполагаем, что иконки находятся в папке static/images/landingMarketPlace/
import CartIcon from 'static/images/landingMarketPlace/cart.webp';
import RobotIcon from 'static/images/landingMarketPlace/block2II.webp';
import ChartIcon from 'static/images/landingMarketPlace/block1money.webp';

export const TransferSection = ({ refProp }) => {
    const features = [
        {
            icon: CartIcon,
            title: 'Создадим магазин\nв Telegram за 3 минуты',
            description:
                'Перенесем все товары в магазин Telegram. Быстрый старт станет вашим преимуществом.',
        },
        {
            icon: RobotIcon,
            title: 'ИИ-продавец для вашего магазина',
            description:
                'Знает всё о вашем ассортименте, помогает выбрать и ответит на любой вопрос!',
        },
        {
            icon: ChartIcon,
            title: 'Запускайте витрину в Telegram',
            description:
                'клиенты узнают о ваших товарах прямо в мессенджере и совершают покупки на маркетплейсах!',
        },
    ];

    return (
        <TransferWrapper ref={refProp}>
            <Title>Удобный перенос магазина в Telegram</Title>
            <FeaturesContainer>
                {features.map((feature, index) => (
                    <FeatureCard key={index}>
                        <IconContainer>
                            <img src={feature.icon} alt={feature.title} />
                        </IconContainer>
                        <FeatureTitle>{feature.title}</FeatureTitle>
                        <FeatureDescription>
                            {feature.description}
                        </FeatureDescription>
                    </FeatureCard>
                ))}
            </FeaturesContainer>
        </TransferWrapper>
    );
};

const TransferWrapper = styled.section`
    padding: 80px 0;
    width: 100%;
`;

const Title = styled.h2`
    font-size: 32px;
    font-weight: 700;
    line-height: 1.2;
    color: #1a1a1a;
    margin: 0 0 48px;
    font-family: 'Unbounded';

    @media (max-width: 992px) {
        font-size: 28px;
        text-align: center;
        margin-bottom: 32px;
        br {
            display: none;
        }
    }
`;

const FeaturesContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;

    @media (max-width: 992px) {
        gap: 16px;
    }

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 24px;
    }
`;

const FeatureCard = styled.div`
    background: #f8f2ff;
    border-radius: 24px;
    padding: 32px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    transition: transform 0.2s ease-in-out;

    &:hover {
        transform: translateY(-4px);
    }

    @media (max-width: 992px) {
        padding: 24px;
    }

    @media (max-width: 768px) {
        width: 100%;
        margin: 0 auto;
    }
`;

const IconContainer = styled.div`
    width: 190px;
    height: 190px;
    margin-bottom: 24px;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    @media (max-width: 992px) {
        width: 120px;
        height: 120px;
        margin-bottom: 16px;
    }
`;

const FeatureTitle = styled.h3`
    font-size: 24px;
    font-weight: 700;
    line-height: 1.3;
    color: #1a1a1a;
    margin: 0 0 16px;
    white-space: pre-line;

    @media (max-width: 992px) {
        font-size: 20px;
        margin: 0 0 12px;
    }
`;

const FeatureDescription = styled.p`
    font-size: 16px;
    line-height: 1.5;
    color: #666666;
    margin: 0;

    @media (max-width: 992px) {
        font-size: 14px;
    }
`;
